import { useTypesStore } from "../store/Types.js";
import { useTypesRender } from "../utils/useRender.js";
export var Set = props => {
  var {
    Set: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Set');
  return null;
};
Set.displayName = 'JVR.Set';